import { jsxs as c, jsx as t } from "react/jsx-runtime";
import { a2 as r, aw as d, d as f } from "../../vendor-CPVnY93G.js";
import { forwardRef as h } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as b } from "../../utils/omitStyleRenderProps/index.js";
import { FieldDescription as u } from "../FieldDescription/index.js";
import { FieldLabel as w } from "../FieldLabel/index.js";
import '../../assets/index54.css';const x = "_switchWrapper_1rs3a_1", N = "_control_1rs3a_41", $ = "_track_1rs3a_47", R = "_thumb_1rs3a_60", j = "_compact_1rs3a_111", k = "_label_1rs3a_122", a = {
  switchWrapper: x,
  switch: "_switch_1rs3a_1",
  control: N,
  track: $,
  thumb: R,
  compact: j,
  label: k
}, L = h(
  ({ children: s, description: o, compact: e = !1, labelRef: l, autoFocus_I_READ_THE_JSDOC: i, ...n }, p) => {
    const m = r(p), _ = r(l);
    return /* @__PURE__ */ c(
      "div",
      {
        "data-component": "Switch",
        className: f(a.switchWrapper, e ? a.compact : null),
        children: [
          /* @__PURE__ */ c(
            d,
            {
              ...b(n),
              slot: void 0,
              autoFocus: i,
              ref: _,
              inputRef: m,
              className: a.switch,
              children: [
                /* @__PURE__ */ t(w, { className: a.label, children: s }),
                /* @__PURE__ */ t("span", { className: a.control, "aria-hidden": "true", children: /* @__PURE__ */ t("span", { className: a.track, children: /* @__PURE__ */ t("span", { className: a.thumb }) }) })
              ]
            }
          ),
          /* @__PURE__ */ t(u, { children: o })
        ]
      }
    );
  }
);
export {
  L as Switch
};
